import { aact, type aactCredType, aactDocumentTypes } from './carriers/aact.js'
import { abfl, type abflCredType } from './carriers/abfl.js'
import { abfs, type abfsCredType, abfsDocumentTypes } from './carriers/abfs.js'
import { agce, type agceCredType, agceDocumentTypes } from './carriers/agce.js'
import { ancf, type ancfCredType, ancfDocumentTypes } from './carriers/ancf.js'
import { avrt, type avrtCredType, avrtDocumentTypes } from './carriers/avrt.js'
import { btvp, type btvpCredType, btvpDocumentTypes } from './carriers/btvp.js'
import { btyt, type btytCredType, btytDocumentTypes } from './carriers/btyt.js'
import { ccyq, type ccyqCredType, ccyqDocumentTypes } from './carriers/ccyq.js'
import { celf, type celfCredType, celfDocumentTypes } from './carriers/celf.js'
import { cevv, type cevvCredType } from './carriers/cevv.js'
import { cffo, type cffoCredType, cffoDocumentTypes } from './carriers/cffo.js'
import { cfwl, type cfwlCredType, cfwlDocumentTypes } from './carriers/cfwl.js'
import { cgoj, type cgojCredType } from './carriers/cgoj.js'
import { ckco, type ckcoCredType } from './carriers/ckco.js'
import { cllq, type cllqCredType, cllqDocumentTypes } from './carriers/cllq.js'
import { cmfc, type cmfcCredType, cmfcDocumentTypes } from './carriers/cmfc.js'
import { cnwy, type cnwyCredType, cnwyDocumentTypes } from './carriers/cnwy.js'
import { csap, type csapCredType, csapDocumentTypes } from './carriers/csap.js'
import { ctbv, type ctbvCredType, ctbvDocumentTypes } from './carriers/ctbv.js'
import { ctii, type ctiiCredType, ctiiDocumentTypes } from './carriers/ctii.js'
import { cxit, type cxitCredType, cxitDocumentTypes } from './carriers/cxit.js'
import { dafg, type dafgCredType, dafgDocumentTypes } from './carriers/dafg.js'
import { dayr, type dayrCredType, dayrDocumentTypes } from './carriers/dayr.js'
import { dbde, type dbdeCredType, dbdeDocumentTypes } from './carriers/dbde.js'
import { ddmt, type ddmtCredType, ddmtDocumentTypes } from './carriers/ddmt.js'
import { ddpp, type ddppCredType, ddppDocumentTypes } from './carriers/ddpp.js'
import { dhlc, type dhlcCredType } from './carriers/dhlc.js'
import { dhrn, type dhrnCredType, dhrnDocumentTypes } from './carriers/dhrn.js'
import { dlds, type dldsCredType, dldsDocumentTypes } from './carriers/dlds.js'
import { dlwi, type dlwiCredType } from './carriers/dlwi.js'
import { dubl, type dublCredType, dublDocumentTypes } from './carriers/dubl.js'
import { dylt, type dyltCredType, dyltDocumentTypes } from './carriers/dylt.js'
import { echs, type echsCredType, echsDocumentTypes } from './carriers/echs.js'
import { edxi, type edxiCredType } from './carriers/edxi.js'
import { exla, type exlaCredType, exlaDocumentTypes } from './carriers/exla.js'
import { fcsy, type fcsyCredType, fcsyDocumentTypes } from './carriers/fcsy.js'
import { ftsc, type ftscCredType, ftscDocumentTypes } from './carriers/ftsc.js'
import { fwdn, type fwdnCredType, fwdnDocumentTypes } from './carriers/fwdn.js'
import { fxfe, type fxfeCredType, fxfeDocumentTypes } from './carriers/fxfe.js'
import { gdco, type gdcoCredType, gdcoDocumentTypes } from './carriers/gdco.js'
import { gelj, type geljCredType, geljDocumentTypes } from './carriers/gelj.js'
import { gson, type gsonCredType } from './carriers/gson.js'
import { gtjn, type gtjnCredType, gtjnDocumentTypes } from './carriers/gtjn.js'
import { hjbi, type hjbiCredType } from './carriers/hjbi.js'
import { hjbt, type hjbtCredType } from './carriers/hjbt.js'
import { hlnf, type hlnfCredType } from './carriers/hlnf.js'
import { hrcf, type hrcfCredType } from './carriers/hrcf.js'
import { hwep, type hwepCredType, hwepDocumentTypes } from './carriers/hwep.js'
import { jbhu, type jbhuCredType } from './carriers/jbhu.js'
import { jlei, type jleiCredType, jleiDocumentTypes } from './carriers/jlei.js'
import { jpxs, type jpxsCredType, jpxsDocumentTypes } from './carriers/jpxs.js'
import { kidy, type kidyCredType, kidyDocumentTypes } from './carriers/kidy.js'
import { ldtn, type ldtnCredType, ldtnDocumentTypes } from './carriers/ldtn.js'
import { llsf, type llsfCredType } from './carriers/llsf.js'
import { mani, type maniCredType, maniDocumentTypes } from './carriers/mani.js'
import { mgul, type mgulCredType, mgulDocumentTypes } from './carriers/mgul.js'
import { mihd, type mihdCredType, mihdDocumentTypes } from './carriers/mihd.js'
import { mllr, type mllrCredType, mllrDocumentTypes } from './carriers/mllr.js'
import { monc, type moncCredType } from './carriers/monc.js'
import { mtjg, type mtjgCredType, mtjgDocumentTypes } from './carriers/mtjg.js'
import { myle, type myleCredType, myleDocumentTypes } from './carriers/myle.js'
import { nmtf, type nmtfCredType, nmtfDocumentTypes } from './carriers/nmtf.js'
import { nopk, type nopkCredType, nopkDocumentTypes } from './carriers/nopk.js'
import { numk, type numkCredType, numkDocumentTypes } from './carriers/numk.js'
import { oakh, type oakhCredType, oakhDocumentTypes } from './carriers/oakh.js'
import { odfl, type odflCredType, odflDocumentTypes } from './carriers/odfl.js'
import { paaf, type paafCredType } from './carriers/paaf.js'
import { pana, type panaCredType, panaDocumentTypes } from './carriers/pana.js'
import { pens, type pensCredType } from './carriers/pens.js'
import { pfeg, type pfegCredType, pfegDocumentTypes } from './carriers/pfeg.js'
import { pgal, type pgalCredType } from './carriers/pgal.js'
import { pit1, type pit1CredType } from './carriers/pit1.js'
import { pitd, type pitdCredType, pitdDocumentTypes } from './carriers/pitd.js'
import { pmli, type pmliCredType, pmliDocumentTypes } from './carriers/pmli.js'
import { polt, type poltCredType, poltDocumentTypes } from './carriers/polt.js'
import { pyle, type pyleCredType, pyleDocumentTypes } from './carriers/pyle.js'
import { quca, type qucaCredType, qucaDocumentTypes } from './carriers/quca.js'
import { rblt, type rbltCredType, rbltDocumentTypes } from './carriers/rblt.js'
import { rdfs, type rdfsCredType, rdfsDocumentTypes } from './carriers/rdfs.js'
import { rlca, type rlcaCredType, rlcaDocumentTypes } from './carriers/rlca.js'
import { roco, type rocoCredType, rocoDocumentTypes } from './carriers/roco.js'
import { rude, type rudeCredType, rudeDocumentTypes } from './carriers/rude.js'
import { rxic, type rxicCredType, rxicDocumentTypes } from './carriers/rxic.js'
import { saia, type saiaCredType, saiaDocumentTypes } from './carriers/saia.js'
import { scnn, type scnnCredType } from './carriers/scnn.js'
import { sefl, type seflCredType, seflDocumentTypes } from './carriers/sefl.js'
import { sfcl, type sfclCredType, sfclDocumentTypes } from './carriers/sfcl.js'
import { sfpa, type sfpaCredType, sfpaDocumentTypes } from './carriers/sfpa.js'
import { slcy, type slcyCredType } from './carriers/slcy.js'
import { smtl, type smtlCredType, smtlDocumentTypes } from './carriers/smtl.js'
import { sncy, type sncyCredType } from './carriers/sncy.js'
import { sztg, type sztgCredType, sztgDocumentTypes } from './carriers/sztg.js'
import { taxa, type taxaCredType, taxaDocumentTypes } from './carriers/taxa.js'
import { tfin, type tfinCredType, tfinDocumentTypes } from './carriers/tfin.js'
import { tmka, type tmkaCredType } from './carriers/tmka.js'
import { tmor, type tmorCredType, tmorDocumentTypes } from './carriers/tmor.js'
import { totl, type totlCredType, totlDocumentTypes } from './carriers/totl.js'
import { tqyl, type tqylCredType } from './carriers/tqyl.js'
import { ttfy, type ttfyCredType, ttfyDocumentTypes } from './carriers/ttfy.js'
import { upgf, type upgfCredType } from './carriers/upgf.js'
import { upss, type upssCredType } from './carriers/upss.js'
import { usco, type uscoCredType, uscoDocumentTypes } from './carriers/usco.js'
import { usiw, type usiwCredType, usiwDocumentTypes } from './carriers/usiw.js'
import { usrd, type usrdCredType, usrdDocumentTypes } from './carriers/usrd.js'
import { utpa, type utpaCredType, utpaDocumentTypes } from './carriers/utpa.js'
import { valc, type valcCredType } from './carriers/valc.js'
import { vity, type vityCredType, vityDocumentTypes } from './carriers/vity.js'
import { vkmf, type vkmfCredType, vkmfDocumentTypes } from './carriers/vkmf.js'
import { vsxp, type vsxpCredType } from './carriers/vsxp.js'
import { ward, type wardCredType, wardDocumentTypes } from './carriers/ward.js'
import { warw, type warwCredType, warwDocumentTypes } from './carriers/warw.js'
import { wlon, type wlonCredType, wlonDocumentTypes } from './carriers/wlon.js'
import { wtch, type wtchCredType, wtchDocumentTypes } from './carriers/wtch.js'
import { xgsi, type xgsiCredType, xgsiDocumentTypes } from './carriers/xgsi.js'
import { zpxs, type zpxsCredType } from './carriers/zpxs.js'
import { type CarrierDef } from './common.js'
import { type Scac } from './scacs.js'

export const Carriers: Record<Scac, CarrierDef<string>> = {
  aact,
  abfl,
  abfs,
  agce,
  ancf,
  avrt,
  btvp,
  btyt,
  ccyq,
  celf,
  cevv,
  cffo,
  cfwl,
  cgoj,
  ckco,
  cllq,
  cmfc,
  cnwy,
  csap,
  ctbv,
  ctii,
  cxit,
  dafg,
  dayr,
  dbde,
  ddpp,
  ddmt,
  dhlc,
  dhrn,
  dlds,
  dlwi,
  dubl,
  dylt,
  echs,
  edxi,
  exla,
  fcsy,
  ftsc,
  fwdn,
  fxfe,
  gdco,
  gelj,
  gson,
  gtjn,
  hjbi,
  jbhu,
  hjbt,
  hlnf,
  hrcf,
  hwep,
  jlei,
  jpxs,
  kidy,
  ldtn,
  llsf,
  mani,
  mgul,
  mihd,
  mllr,
  monc,
  mtjg,
  myle,
  nmtf,
  nopk,
  numk,
  oakh,
  odfl,
  paaf,
  pana,
  pens,
  pfeg,
  pgal,
  pit1,
  pitd,
  pmli,
  polt,
  pyle,
  quca,
  rblt,
  rdfs,
  rlca,
  roco,
  rude,
  rxic,
  saia,
  scnn,
  sefl,
  sfcl,
  sfpa,
  slcy,
  smtl,
  sncy,
  sztg,
  taxa,
  tfin,
  tmka,
  tmor,
  totl,
  tqyl,
  ttfy,
  upgf,
  upss,
  usco,
  usiw,
  usrd,
  utpa,
  valc,
  vity,
  vkmf,
  vsxp,
  ward,
  warw,
  wlon,
  wtch,
  xgsi,
  zpxs,
}

export type {
  aactCredType,
  abflCredType,
  abfsCredType,
  agceCredType,
  ancfCredType,
  avrtCredType,
  btvpCredType,
  btytCredType,
  ccyqCredType,
  celfCredType,
  cevvCredType,
  cffoCredType,
  cfwlCredType,
  cgojCredType,
  ckcoCredType,
  cllqCredType,
  cmfcCredType,
  cnwyCredType,
  csapCredType,
  ctbvCredType,
  ctiiCredType,
  cxitCredType,
  dafgCredType,
  dayrCredType,
  dbdeCredType,
  ddmtCredType,
  ddppCredType,
  dhlcCredType,
  dhrnCredType,
  dldsCredType,
  dlwiCredType,
  dublCredType,
  dyltCredType,
  echsCredType,
  edxiCredType,
  exlaCredType,
  fcsyCredType,
  ftscCredType,
  fwdnCredType,
  fxfeCredType,
  gdcoCredType,
  geljCredType,
  gsonCredType,
  gtjnCredType,
  hjbiCredType,
  hjbtCredType,
  hlnfCredType,
  hrcfCredType,
  hwepCredType,
  jbhuCredType,
  jleiCredType,
  jpxsCredType,
  kidyCredType,
  ldtnCredType,
  llsfCredType,
  maniCredType,
  mgulCredType,
  mihdCredType,
  mllrCredType,
  moncCredType,
  mtjgCredType,
  myleCredType,
  nmtfCredType,
  nopkCredType,
  numkCredType,
  oakhCredType,
  odflCredType,
  paafCredType,
  panaCredType,
  pensCredType,
  pfegCredType,
  pgalCredType,
  pit1CredType,
  pitdCredType,
  pmliCredType,
  poltCredType,
  pyleCredType,
  qucaCredType,
  rbltCredType,
  rdfsCredType,
  rlcaCredType,
  rocoCredType,
  rudeCredType,
  rxicCredType,
  saiaCredType,
  scnnCredType,
  seflCredType,
  sfclCredType,
  sfpaCredType,
  slcyCredType,
  smtlCredType,
  sncyCredType,
  sztgCredType,
  taxaCredType,
  tfinCredType,
  tmorCredType,
  totlCredType,
  tqylCredType,
  ttfyCredType,
  upgfCredType,
  upssCredType,
  uscoCredType,
  usiwCredType,
  usrdCredType,
  utpaCredType,
  valcCredType,
  vityCredType,
  vkmfCredType,
  vsxpCredType,
  wardCredType,
  warwCredType,
  wlonCredType,
  wtchCredType,
  xgsiCredType,
  zpxsCredType,
}

export type CredTypes =
  | aactCredType
  | abflCredType
  | abfsCredType
  | agceCredType
  | ancfCredType
  | avrtCredType
  | btvpCredType
  | btytCredType
  | ccyqCredType
  | celfCredType
  | cevvCredType
  | cffoCredType
  | cfwlCredType
  | cgojCredType
  | ckcoCredType
  | cllqCredType
  | cmfcCredType
  | cnwyCredType
  | csapCredType
  | ctbvCredType
  | ctiiCredType
  | cxitCredType
  | dafgCredType
  | dayrCredType
  | dbdeCredType
  | ddppCredType
  | ddmtCredType
  | dhlcCredType
  | dhrnCredType
  | dldsCredType
  | dlwiCredType
  | dublCredType
  | dyltCredType
  | echsCredType
  | edxiCredType
  | exlaCredType
  | fcsyCredType
  | ftscCredType
  | fwdnCredType
  | fxfeCredType
  | gdcoCredType
  | geljCredType
  | gsonCredType
  | gtjnCredType
  | hjbiCredType
  | hjbtCredType
  | hlnfCredType
  | hrcfCredType
  | hwepCredType
  | jbhuCredType
  | jleiCredType
  | jpxsCredType
  | kidyCredType
  | ldtnCredType
  | llsfCredType
  | maniCredType
  | mgulCredType
  | mihdCredType
  | mllrCredType
  | moncCredType
  | mtjgCredType
  | myleCredType
  | nmtfCredType
  | nopkCredType
  | numkCredType
  | oakhCredType
  | odflCredType
  | paafCredType
  | panaCredType
  | pensCredType
  | pfegCredType
  | pgalCredType
  | pit1CredType
  | pitdCredType
  | pmliCredType
  | poltCredType
  | pyleCredType
  | qucaCredType
  | rbltCredType
  | rdfsCredType
  | rlcaCredType
  | rocoCredType
  | rudeCredType
  | rxicCredType
  | saiaCredType
  | scnnCredType
  | seflCredType
  | sfclCredType
  | sfpaCredType
  | slcyCredType
  | smtlCredType
  | sncyCredType
  | sztgCredType
  | taxaCredType
  | tfinCredType
  | tmorCredType
  | tmkaCredType
  | totlCredType
  | tqylCredType
  | ttfyCredType
  | upgfCredType
  | upssCredType
  | uscoCredType
  | usiwCredType
  | usrdCredType
  | utpaCredType
  | valcCredType
  | vityCredType
  | vkmfCredType
  | vsxpCredType
  | wardCredType
  | warwCredType
  | wlonCredType
  | wtchCredType
  | xgsiCredType
  | zpxsCredType

export {
  aactDocumentTypes,
  abfsDocumentTypes,
  agceDocumentTypes,
  ancfDocumentTypes,
  avrtDocumentTypes,
  btvpDocumentTypes,
  btytDocumentTypes,
  ccyqDocumentTypes,
  celfDocumentTypes,
  cffoDocumentTypes,
  cfwlDocumentTypes,
  cllqDocumentTypes,
  cmfcDocumentTypes,
  cnwyDocumentTypes,
  csapDocumentTypes,
  ctbvDocumentTypes,
  ctiiDocumentTypes,
  cxitDocumentTypes,
  dafgDocumentTypes,
  dayrDocumentTypes,
  dbdeDocumentTypes,
  ddmtDocumentTypes,
  ddppDocumentTypes,
  dhrnDocumentTypes,
  dldsDocumentTypes,
  dublDocumentTypes,
  dyltDocumentTypes,
  echsDocumentTypes,
  exlaDocumentTypes,
  fcsyDocumentTypes,
  ftscDocumentTypes,
  fwdnDocumentTypes,
  fxfeDocumentTypes,
  gdcoDocumentTypes,
  geljDocumentTypes,
  gtjnDocumentTypes,
  hwepDocumentTypes,
  jleiDocumentTypes,
  jpxsDocumentTypes,
  kidyDocumentTypes,
  ldtnDocumentTypes,
  maniDocumentTypes,
  mgulDocumentTypes,
  mihdDocumentTypes,
  mllrDocumentTypes,
  mtjgDocumentTypes,
  myleDocumentTypes,
  nmtfDocumentTypes,
  nopkDocumentTypes,
  numkDocumentTypes,
  oakhDocumentTypes,
  odflDocumentTypes,
  panaDocumentTypes,
  pfegDocumentTypes,
  pitdDocumentTypes,
  pmliDocumentTypes,
  poltDocumentTypes,
  pyleDocumentTypes,
  qucaDocumentTypes,
  rbltDocumentTypes,
  rdfsDocumentTypes,
  rlcaDocumentTypes,
  rocoDocumentTypes,
  rudeDocumentTypes,
  rxicDocumentTypes,
  saiaDocumentTypes,
  seflDocumentTypes,
  sfclDocumentTypes,
  sfpaDocumentTypes,
  smtlDocumentTypes,
  sztgDocumentTypes,
  taxaDocumentTypes,
  tfinDocumentTypes,
  tmorDocumentTypes,
  totlDocumentTypes,
  ttfyDocumentTypes,
  uscoDocumentTypes,
  usiwDocumentTypes,
  usrdDocumentTypes,
  utpaDocumentTypes,
  vityDocumentTypes,
  vkmfDocumentTypes,
  wardDocumentTypes,
  warwDocumentTypes,
  wlonDocumentTypes,
  wtchDocumentTypes,
  xgsiDocumentTypes,
}
